import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
} from "@mui/material";
import { useState } from "react";
import axiosGenerico from "../utils/axiosGenerico";
import { useAuth } from "../context/auth-context";
import { useCargando } from "../context/cargando-context";
import { useSnackbar } from "notistack";

interface ResetPasswordProps {
  openDialog: boolean;
  handleDialogClose: () => void;
}

const ResetPassword = ({
  openDialog,
  handleDialogClose,
}: ResetPasswordProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const { empezarCarga, terminarCarga } = useCargando();
  const { cliente } = useAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = async () => {
    if (!validatePassword()) {
      return;
    }
    try {
      empezarCarga();
      await axiosGenerico
        .put("/cliente/update-password", {
          cliente: cliente.codigo,
          currentPassword,
          newPassword,
        })
        .then((response) => {
          enqueueSnackbar("Contraseña cambiada correctamente", {
            variant: "success",
          });
          handleClose();
        });
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Error al cambiar la contraseña", { variant: "error" });
    } finally {
      terminarCarga();
    }
  };

  const validatePassword = () => {
    return newPassword === confirmPassword;
  };

  const handleClose = () => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    handleDialogClose();
  };

  return (
    <Dialog open={openDialog} onClose={handleDialogClose}>
      <DialogTitle>Cambiar Contraseña</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          autoComplete="false"
          margin="normal"
          label="Contraseña actual"
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
        />
        <TextField
          fullWidth
          autoComplete="false"
          margin="normal"
          label="Nueva contraseña"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <TextField
          fullWidth
          autoComplete="false"
          error={!validatePassword()}
          helperText={!validatePassword() && "Las contraseñas no coinciden"}
          margin="normal"
          label="Confirmar nueva contraseña"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleSubmit} color="primary">
          Cambiar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetPassword;
